// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3R0uq","Label":"BuildControl_Label__3l8Y9","Less":"BuildControl_Less__1F1Zu","More":"BuildControl_More__1YvmJ"};